<template>
  <div>
    <a-row>
      <a-col
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
        style="margin-top: 10px"
      >
        <div class="card-container">
          <a-tabs
            type="card"
            :activeKey="this.perturbseqtype"
            defaultActiveKey="1"
            @change="callback"
          >
            <a-tab-pane key="1" tab="Perturb-Seq">
              <scSeq />
            </a-tab-pane>
            <a-tab-pane key="2" tab="Perturbation scATAC-Seq">
              <atac />
            </a-tab-pane>
            <a-tab-pane key="3" tab="Bulk perturbation RNA-Seq">
              <bulkSeq />
            </a-tab-pane>
          </a-tabs>
        </div>
      </a-col>
      <a-col
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
        style="margin-top: -20px"
      >
      </a-col>
    </a-row>
  </div>
</template>
<script>
import bulkSeq from "./bulkSeq.vue";
import scSeq from "./scSeq.vue";
import atac from "../scATACseq/atacSeq.vue";

export default {
  components: { bulkSeq, scSeq, atac },
  data() {
    return {
      perturbseqtype: "1",
    };
  },
  mounted() {
    if (this.$route.query.perturbstype != "") {
      if (this.$route.query.perturbstype == "bulk") {
        this.perturbseqtype = "3";
      } else if (this.$route.query.perturbstype == "scRNA") {
        this.perturbseqtype = "1";
      } else if (this.$route.query.perturbstype == "scATAC") {
        this.perturbseqtype = "2";
      }
    }
  },
  methods: {
    callback(key) {
      this.perturbseqtype = key;
    },
  },
};
</script>
<style scpoed>
.h1 {
  font-size: 40px;
  font-weight: bolder;
}
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}
.card-container {
  background: #f5f5f5;
  overflow: hidden;
  padding: 4px;
}
</style>
